import React, { useContext, memo } from 'react';
import { StackingOrder } from '../../constants';
import StackingContext from './StackingContext';
var Stack = /*#__PURE__*/memo(function Stack(_ref) {
  var children = _ref.children,
      _ref$value = _ref.value,
      value = _ref$value === void 0 ? StackingOrder.STACKING_CONTEXT : _ref$value;
  var previousValue = useContext(StackingContext);
  var currentValue = Math.max(value, previousValue);
  var nextValue = currentValue + 1;
  return /*#__PURE__*/React.createElement(StackingContext.Provider, {
    value: nextValue
  }, children(currentValue));
});
export default Stack;